import axios from 'axios';

export async function requestPasswordReset(email) {
    const res = await axios.post('/api/password/forgot', { email });
    return res.data;
}

export async function resetPassword(token, password, passwordConfirm) {
    const res = await axios.post('/api/password/reset', { token, password, passwordConfirm });
    return res.data;
}